import React from 'react';
import PropTypes from 'prop-types';

export const CloseIcon = ({ color = 'black', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.9 17.7" {...props}>
    <path
      fill={color}
      d="M17.9 16.1l-7.5-7.3 7.4-7.4L16.4 0 8.9 7.4 1.4.1 0 1.6l7.5 7.3-7.4 7.4 1.4 1.4L9 10.2l7.5 7.4"
    />
  </svg>
);

CloseIcon.propTypes = {
  color: PropTypes.string
};
